
import { Vue, Component } from 'vue-property-decorator';
import { notification } from 'ant-design-vue';
import { EventBus } from '@/helpers/EventBusHelper';
import { EventBusEvents } from '@/enums/global/EventBusEvents';
import { LocalStorageService } from '@/services/LocalStorageService';
import { LocalStorageKeyNames } from '@/enums/global/LocalStorageKeyNames';
import HealthCheckService from '@/services/HealthCheckService';
import i18n from '@/i18n';

type LightColor = 'green' | 'yellow' | 'red';

const SERVER_SLOW_MS = 5000;
const BASELINE_SLOW_MS = 1000;
const NOTIFICATION_COOLDOWN_MS = 60000;
const BASELINE_CHECK_INTERVAL_MS = 60000;

@Component({ name: 'PerformanceTrafficLight' })
export default class PerformanceTrafficLight extends Vue {
  private lastNotifiedAt = 0;
  private baselineMs: number | null = null;
  private baselineIntervalHandle: number | null = null;

  private onRequestTiming = (payload: { rttMs: number; serverMs: number | null; url: string }) => {
    const { rttMs, serverMs } = payload;
    if (serverMs == null) {
      return;
    }
    const networkMs = rttMs - serverMs;
    let color: LightColor = 'green';
    if (serverMs > SERVER_SLOW_MS) {
      color = 'red';
    } else if (networkMs > BASELINE_SLOW_MS) {
      color = 'yellow';
    }

    if (color === 'green') {
      return;
    }

    const now = Date.now();
    const cooldownExpired = now - this.lastNotifiedAt > NOTIFICATION_COOLDOWN_MS;

    if (!cooldownExpired) {
      return;
    }

    this.lastNotifiedAt = now;

    if (color === 'red') {
      notification.error({
        message: i18n.t('Spori serveri') as string,
        description: `${i18n.t('Backend je odgovorio za')} ${serverMs}ms`,
      });
    } else {
      notification.warning({
        message: i18n.t('Spora veza') as string,
        description: i18n.t('Vaša internet veza je spora') as string,
      });
    }
  };

  private async refreshBaseline() {
    this.baselineMs = await HealthCheckService.checkNetworkBaseline();
  }

  private mounted() {
    if (!LocalStorageService.has(LocalStorageKeyNames.token)) {
      return;
    }
    this.refreshBaseline();
    this.baselineIntervalHandle = window.setInterval(this.refreshBaseline, BASELINE_CHECK_INTERVAL_MS);
    EventBus.$on(EventBusEvents.requestTiming, this.onRequestTiming);
  }

  private beforeDestroy() {
    if (this.baselineIntervalHandle !== null) {
      clearInterval(this.baselineIntervalHandle);
    }
    EventBus.$off(EventBusEvents.requestTiming, this.onRequestTiming);
  }
}
